<template>
  <td
    :class="{ 'cursor-pointer': !hideDialog, caption: small }"
    @click="hideDialog ? null : $emit('click')"
  >
    <div
      :class="{ 'white--border': !dark, 'pa-2': value.hideValues }"
      v-bind:style="{
        backgroundColor: backgroundColor
      }"
    >
      <anonymous-icon v-if="value.hideValues"> </anonymous-icon>
      <template v-else-if="count">
        {{ value.value | no_decimal }}
      </template>
      <template v-else-if="value.value == 0">
        NA
      </template>
      <template v-else>
        {{ value.value | one_decimal }}
      </template>
    </div>
  </td>
</template>

<script>
import AnonymousIcon from "@/components/common/AnonymousIcon";
export default {
  name: "HeatmapCell",
  components: { AnonymousIcon },
  props: {
    value: { type: Object, default: null },
    count: { type: Boolean, default: false },
    dark: { type: Boolean, default: false },
    small: { type: Boolean, default: false }
  },
  computed: {
    hideDialog() {
      return this.value.hideValues || this.value.value == 0;
    },
    backgroundColor() {
      let color = "#fff";
      let opacity = 1;
      if (this.dark) {
        color = this.$vuetify.theme.themes.light.background;
      } else if (
        !this.count &&
        !this.value.hideValues &&
        this.value.value > 0
      ) {
        color = this.$coreScores.getColor(this.value.value);
        opacity = this.$coreScores.getOpacity(this.value.value);
      }

      return this.getColor(color, opacity);
    }
  }
};
</script>
